(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6186],{

/***/ 94967:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary/[id]/[keyword]",
      function () {
        return __webpack_require__(7287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18138);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d2a85e6a-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 70691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var Delete = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8 8.93333L6.06666 10.8667C5.94444 10.9889 5.78889 11.05 5.6 11.05C5.41111 11.05 5.25555 10.9889 5.13333 10.8667C5.01111 10.7444 4.95 10.5889 4.95 10.4C4.95 10.2111 5.01111 10.0555 5.13333 9.93333L7.06666 7.99999L5.13333 6.08333C5.01111 5.9611 4.95 5.80555 4.95 5.61666C4.95 5.42777 5.01111 5.27222 5.13333 5.14999C5.25555 5.02777 5.41111 4.96666 5.6 4.96666C5.78889 4.96666 5.94444 5.02777 6.06666 5.14999L8 7.08333L9.91666 5.14999C10.0389 5.02777 10.1944 4.96666 10.3833 4.96666C10.5722 4.96666 10.7278 5.02777 10.85 5.14999C10.9833 5.28333 11.05 5.44166 11.05 5.62499C11.05 5.80833 10.9833 5.9611 10.85 6.08333L8.91666 7.99999L10.85 9.93333C10.9722 10.0555 11.0333 10.2111 11.0333 10.4C11.0333 10.5889 10.9722 10.7444 10.85 10.8667C10.7167 11 10.5583 11.0667 10.375 11.0667C10.1917 11.0667 10.0389 11 9.91666 10.8667L8 8.93333Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Delete);


/***/ }),

/***/ 71305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var HealthMedicalMedicines = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6240_2327)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.6198 6.84864C11.207 6.26149 12.0032 5.93164 12.8336 5.93164C13.6639 5.93164 14.4603 6.26149 15.0475 6.84864C15.6346 7.43578 15.9645 8.23211 15.9645 9.06245C15.9645 9.8928 15.6346 10.6891 15.0475 11.2763L11.2545 15.0691C10.6674 15.6563 9.87107 15.9862 9.04072 15.9862C8.21038 15.9862 7.41405 15.6563 6.82691 15.0691C6.23976 14.4821 5.90991 13.6857 5.90991 12.8553C5.90991 12.025 6.23976 11.2287 6.82691 10.6415L10.6198 6.84864Z",
                        fill: "#EF990D"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.8335 5.93164C12.0031 5.93164 11.2069 6.26149 10.6197 6.84864L8.72327 8.74508L13.1509 13.1727L15.0474 11.2763C15.6345 10.6891 15.9644 9.8928 15.9644 9.06245C15.9644 8.23211 15.6345 7.43578 15.0474 6.84864C14.4602 6.26149 13.6638 5.93164 12.8335 5.93164Z",
                        fill: "#F4B54F"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.43509 8.87016C6.8845 8.87016 8.87016 6.8845 8.87016 4.43509C8.87016 1.98566 6.8845 0 4.43509 0C1.98566 0 0 1.98566 0 4.43509C0 6.8845 1.98566 8.87016 4.43509 8.87016Z",
                        fill: "#339AF0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0.0572177 5.14927H8.81294C8.85059 4.91675 8.87016 4.67815 8.87016 4.43499C8.87016 4.19182 8.85059 3.95324 8.81294 3.7207H0.0572177C0.0195689 3.95324 0 4.19182 0 4.43499C0 4.67815 0.0195689 4.91675 0.0572177 5.14927Z",
                        fill: "#86C6FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6240_2327",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HealthMedicalMedicines);


/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var YouTubePlayer = function(param) {
    var videoUrl = param.videoUrl;
    var videoId = new URL(videoUrl).searchParams.get("v"); // Extract the video ID from the URL
    if (!videoId) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/".concat(videoId),
        title: "YouTube video player",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (YouTubePlayer);


/***/ }),

/***/ 42411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70691);
/* harmony import */ var _constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99529);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95613);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44376);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);







var AppInstallTopBanner = function(param) {
    var onClickClose = param.onClickClose, content = param.content, trackingInfo = param.trackingInfo, onLogEvent = param.onLogEvent;
    var ref = trackingInfo !== null && trackingInfo !== void 0 ? trackingInfo : {}, contentCategory = ref.contentCategory, contentId = ref.contentId, contentTitle = ref.contentTitle, campaign = ref.campaign, contentSubCategory = ref.contentSubCategory;
    var airbridgeDynamicLink = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAirbridgeDynamicLink */ .e)();
    var onClickInstallApp = function() {
        onLogEvent === null || onLogEvent === void 0 ? void 0 : onLogEvent();
        airbridgeDynamicLink.navigateWithTracking(_constants_logs_deeplink__WEBPACK_IMPORTED_MODULE_2__/* .DeeplinkLoggerEventName.ClickCtaButton */ .l.ClickCtaButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            campaign: campaign,
            content: content,
            term: "바로 진료받기",
            sub_id: contentId,
            sub_id_1: contentTitle,
            sub_id_2: contentCategory
        }, contentSubCategory && {
            sub_id_3: contentSubCategory
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sticky top-[60px] z-[300] flex w-full items-center justify-between bg-gray-700 pt-[14px] pr-[20px] pb-[12px] pl-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onClickClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_SmallDelete__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            color: _styles_theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].color.gray300 */ .Z.color.gray300,
                            size: 24
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-13m text-white",
                                children: "병원 문 닫은 늦은 밤, 주말에도"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "typography-ui-15sb text-white",
                                children: "닥터나우는 24시간 열려있어요!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "typography-ui-13m h-[32px] rounded-lg border bg-primary-600 px-[8px] text-white",
                    onClick: onClickInstallApp,
                    children: "바로 진료받기"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInstallTopBanner);


/***/ }),

/***/ 99529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DeeplinkLoggerEventName; }
/* harmony export */ });
var DeeplinkLoggerEventName;
(function(DeeplinkLoggerEventName) {
    DeeplinkLoggerEventName["ClickCtaButton"] = "click_cta_button";
    DeeplinkLoggerEventName["ImpressionQrFloating"] = "impression_qr_floating";
    DeeplinkLoggerEventName["ClickCtaText"] = "click_cta_text";
})(DeeplinkLoggerEventName || (DeeplinkLoggerEventName = {}));


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 72115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var MedicineDictionaryModel = function MedicineDictionaryModel(data) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, MedicineDictionaryModel);
    this.getPublicId = function() {
        return _this.publicId;
    };
    this.getMedicinePictogramImages = function() {
        var _medicinePictogramImages;
        return (_medicinePictogramImages = _this.basicInfo.medicinePictogramImages) !== null && _medicinePictogramImages !== void 0 ? _medicinePictogramImages : [];
    };
    this.getSimplifiedName = function() {
        return _this.basicInfo.simplifiedName;
    };
    this.getPharmaceuticalEffectLiteracy = function() {
        return _this.basicInfo.pharmaceuticalEffectLiteracy;
    };
    this.getIndications = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.indications) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getDosages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getDosageHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosageHtml;
    };
    this.getSideEffects = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.sideEffects) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getEthicalType = function() {
        var ref;
        return (ref = _this.classificationInfo) === null || ref === void 0 ? void 0 : ref.ethicalType;
    };
    this.getCompanyName = function() {
        var ref;
        return (ref = _this.companyInfo) === null || ref === void 0 ? void 0 : ref.companyName;
    };
    this.getFormattedIngredientName = function() {
        var ref;
        return (ref = _this.ingredientInfo) === null || ref === void 0 ? void 0 : ref.formattedIngredientName;
    };
    this.getStorages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.storages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getCaution = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.cautions) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getInteractionHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.interactionHtml;
    };
    this.getVideoLink = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.videoLink;
    };
    this.getBasicInfoName = function() {
        return _this.basicInfo.name;
    };
    this.getWholeSummary = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.wholeSummary;
    };
    this.getRepresentativeImage = function() {
        var ref;
        var _medicineImage, ref1;
        return (ref1 = (_medicineImage = _this.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : (ref = _this.packagingInfo) === null || ref === void 0 ? void 0 : ref.image) !== null && ref1 !== void 0 ? ref1 : undefined;
    };
    this.getMedicineGuideIndications = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.indications) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideDosages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.dosages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideSideEffects = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.sideEffects) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideCautions = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.cautions) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideStorages = function() {
        var ref;
        var ref1;
        return (ref1 = (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.storages) !== null && ref1 !== void 0 ? ref1 : [];
    };
    this.getMedicineGuideInteractionHtml = function() {
        var ref;
        return (ref = _this.medicineGuide) === null || ref === void 0 ? void 0 : ref.interactionHtml;
    };
    this.id = data.id;
    this.publicId = data.publicId;
    this.basicInfo = data.basicInfo;
    this.classificationInfo = data.classificationInfo;
    this.companyInfo = data.companyInfo;
    this.ingredientInfo = data.ingredientInfo;
    this.medicineGuide = data.medicineGuide;
    this.packagingInfo = data.packagingInfo;
};
/* harmony default export */ __webpack_exports__["Z"] = (MedicineDictionaryModel);


/***/ }),

/***/ 68534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z6": function() { return /* binding */ sanitizeHtml; },
/* harmony export */   "at": function() { return /* binding */ createMedicineDictionaryDetailUrl; },
/* harmony export */   "pT": function() { return /* binding */ createMedicineDictionaryDetailUrlWithKeyword; }
/* harmony export */ });
/* unused harmony exports getMedicineDictionaryImageUrl, createMedicineDictionaryRedirectUrl */
/* harmony import */ var _shared_utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64214);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70138);


var sanitizeHtml = function(html) {
    // tbody가 p 태그 안에 있는 경우를 처리
    var sanitized = html.replace(/<p><tbody>/g, "<table><tbody>");
    sanitized = sanitized.replace(/<\/tbody><\/p>/g, "</tbody></table>");
    // 테이블 스타일링을 위한 클래스 추가
    sanitized = sanitized.replace(/<table>/g, '<table class="w-full border-collapse border border-gray-200 my-4 rounded-lg overflow-hidden">');
    sanitized = sanitized.replace(/<td/g, '<td class="border border-gray-200 px-4 py-3 text-center bg-white"');
    sanitized = sanitized.replace(/<tr>/g, '<tr class="hover:bg-gray-50">');
    // 첫 번째 행(헤더)에 다른 스타일 적용
    sanitized = sanitized.replace(/(<tr class="hover:bg-gray-50">[\s\S]*?<\/tr>)/, function(match) {
        return match.replace("bg-white", "bg-gray-100 font-medium");
    });
    return sanitized;
};
var getMedicineDictionaryImageUrl = function(image, packagingInfoImage) {
    var ref;
    return (ref = image !== null && image !== void 0 ? image : packagingInfoImage) !== null && ref !== void 0 ? ref : undefined;
};
var createMedicineDictionaryDetailUrl = function(medicineDictionary) {
    if (!medicineDictionary) {
        return "";
    }
    var publicId = medicineDictionary.getPublicId();
    var keyword = medicineDictionary.getBasicInfoName() || medicineDictionary.getSimplifiedName();
    var encodedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.MEDICINE_DICTIONARY.DETAIL.path */ .Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var createMedicineDictionaryDetailUrlWithKeyword = function(publicId, keyword) {
    var encodedKeyword = (0,_shared_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatKeywordForUrl */ .Z)(keyword);
    return "".concat(_types_common__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.MEDICINE_DICTIONARY.DETAIL.path */ .Z6.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};
var extractKeywordFromMedicineData = function(medicineData) {
    return medicineData.basicInfo.name || medicineData.basicInfo.simplifiedName;
};
var createMedicineDictionaryRedirectUrl = function(publicId, medicineData) {
    var keyword = extractKeywordFromMedicineData(medicineData);
    var formattedKeyword = formatKeywordForUrl(keyword);
    var encodedKeyword = encodeURIComponent(formattedKeyword);
    return "".concat(ROUTES.MEDICINE_DICTIONARY.DETAIL.path, "/").concat(publicId, "/").concat(encodedKeyword);
};


/***/ }),

/***/ 40573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15951);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9912);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79212);
/* harmony import */ var dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53476);






dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_isSameOrAfter__WEBPACK_IMPORTED_MODULE_3___default()));
var useAppInstallTopBanner = function() {
    var isVisible = (0,recoil__WEBPACK_IMPORTED_MODULE_5__.useRecoilValue)(_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .appInstallTopBannerState */ .Ep).isVisible;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (0,_recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .getAppInstallTopBannerState */ ._l)();
    }, []);
    // 스크롤 기반 가시성 상태
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isScrollVisible = ref[0], setIsScrollVisible = ref[1];
    var lastScrollYRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(0);
    var rafIdRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    // 스크롤 이벤트 핸들러 (RAF 최적화)
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var threshold = 300;
        var handleScroll = function() {
            // RAF가 이미 예약되어 있으면 중복 실행 방지
            if (rafIdRef.current !== null) {
                return;
            }
            rafIdRef.current = requestAnimationFrame(function() {
                var currentScrollY = window.scrollY;
                var lastScrollY = lastScrollYRef.current;
                // threshold 이하에서는 항상 표시
                if (currentScrollY < threshold) {
                    setIsScrollVisible(true);
                } else {
                    // 위로 스크롤: 표시, 아래로 스크롤: 숨김
                    if (currentScrollY < lastScrollY) {
                        setIsScrollVisible(true);
                    } else if (currentScrollY > lastScrollY) {
                        setIsScrollVisible(false);
                    }
                }
                lastScrollYRef.current = currentScrollY;
                rafIdRef.current = null;
            });
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, []);
    var isNewAdVisible = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var targetDate = dayjs__WEBPACK_IMPORTED_MODULE_2___default()("2025-11-12T00:00:00");
        var now = dayjs__WEBPACK_IMPORTED_MODULE_2___default()();
        return now.isSameOrAfter(targetDate, "day");
    }, []);
    var isNewAdVisibleClient = function(client) {
        var visibleClientTypes = [
            _types_app__WEBPACK_IMPORTED_MODULE_1__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB
        ];
        return visibleClientTypes.includes(client.clientType);
    };
    return {
        isVisible: isVisible,
        isNewAdVisible: isNewAdVisible,
        isNewAdVisibleClient: isNewAdVisibleClient,
        isScrollVisible: isScrollVisible,
        hideBanner: _recoil_atoms_cuj_index__WEBPACK_IMPORTED_MODULE_0__/* .hideBanner */ .dl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppInstallTopBanner);


/***/ }),

/***/ 16708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "me": function() { return /* binding */ useMedicineDictionaryItemByPublicIdQuery; },
/* harmony export */   "vi": function() { return /* binding */ usePopularMedicineDictionaryItemsQuery; }
/* harmony export */ });
/* unused harmony exports MedicineDictionaryItemByPublicIdDocument, PopularMedicineDictionaryItemsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var MedicineDictionaryItemByPublicIdDocument = "\n    query MedicineDictionaryItemByPublicId($publicId: String!) {\n  medicineDictionaryItemByPublicId(publicId: $publicId) {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n      medicinePictogramImages\n    }\n    classificationInfo {\n      ethicalType\n    }\n    companyInfo {\n      companyName\n    }\n    ingredientInfo {\n      formattedIngredientName\n    }\n    medicineGuide {\n      interactionHtml\n      indications\n      dosages\n      dosageHtml\n      sideEffects\n      cautions\n      storages\n      videoLink\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var useMedicineDictionaryItemByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "MedicineDictionaryItemByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables), options);
};
useMedicineDictionaryItemByPublicIdQuery.getKey = function(variables) {
    return [
        "MedicineDictionaryItemByPublicId",
        variables
    ];
};
useMedicineDictionaryItemByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(MedicineDictionaryItemByPublicIdDocument, "MedicineDictionaryItemByPublicId", variables, options);
};
var PopularMedicineDictionaryItemsDocument = "\n    query PopularMedicineDictionaryItems {\n  popularMedicineDictionaryItems {\n    id\n    publicId\n    basicInfo {\n      name\n      simplifiedName\n      pharmaceuticalEffectLiteracy\n      medicineImage\n    }\n    medicineGuide {\n      wholeSummary\n    }\n    packagingInfo {\n      image\n    }\n  }\n}\n    ";
var usePopularMedicineDictionaryItemsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables), options);
};
usePopularMedicineDictionaryItemsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "PopularMedicineDictionaryItems"
    ] : [
        "PopularMedicineDictionaryItems",
        variables
    ];
};
usePopularMedicineDictionaryItemsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PopularMedicineDictionaryItemsDocument, "PopularMedicineDictionaryItems", variables, options);
};


/***/ }),

/***/ 35613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10712);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74735);






var NavigatorType;
(function(NavigatorType) {
    NavigatorType["PushScreen"] = "PUSH_SCREEN";
    NavigatorType["ReplaceScreen"] = "REPLACE_SCREEN";
    NavigatorType["PopToTop"] = "POP_TO_TOP";
    NavigatorType["Back"] = "BACK";
    NavigatorType["JumpTo"] = "JUMP_TO";
    NavigatorType["Navigate"] = "NAVIGATE";
})(NavigatorType || (NavigatorType = {}));
var useNavigator = function() {
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), push = _ref.push, replace = _ref.replace, routerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "push",
        "replace"
    ]);
    var query = routerProps.query;
    var pushScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.PushScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var popToTopScreen = function(url, options) {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "?routeType=".concat(NavigatorType.PopToTop));
        }
        if (!url) {
            return;
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push(url);
    };
    var jumpToScreen = function(param, options) {
        var tabName = param.tabName, params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                tabName: tabName,
                routeType: NavigatorType.JumpTo,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return push("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var replaceScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.ReplaceScreen,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var navigateScreen = function(param, options) {
        var params = param.params, url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", "".concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, query), {
                routeType: NavigatorType.Navigate,
                nextUrl: "".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params)))
            }))));
        }
        if (options === null || options === void 0 ? void 0 : options.disabledWebRoute) {
            return;
        }
        return replace("".concat(url).concat((0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)(params)));
    };
    var back = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return window.history.replaceState({}, "", (0,_utils_url__WEBPACK_IMPORTED_MODULE_2__/* .addQueryString */ .sC)({
                routeType: NavigatorType.Back
            }));
        }
        return window.history.back();
    };
    var pushAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var jumpToAppScreen = function(param) {
        var tabName = param.tabName, screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_TAB_HOME */ .nn.MOVE_TO_TAB_HOME, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tabName: tabName,
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var replaceAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var navigateAppScreen = function(param) {
        var screenName = param.screenName, params = param.params;
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.NAVIGATE_TO_PAGE */ .nn.NAVIGATE_TO_PAGE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            screenName: screenName
        }, params && {
            params: params
        }));
    };
    var openExternalBrowser = function(param) {
        var url = param.url;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .isWebView */ .vp)()) {
            return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_1__/* .NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */ .nn.OPEN_EXTERNAL_BROWSER, {
                url: url
            });
        }
        return window.open(url);
    };
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, routerProps), {
        query: query,
        push: push,
        pushScreen: pushScreen,
        popToTopScreen: popToTopScreen,
        jumpToScreen: jumpToScreen,
        replace: replace,
        replaceScreen: replaceScreen,
        navigateScreen: navigateScreen,
        pushAppScreen: pushAppScreen,
        jumpToAppScreen: jumpToAppScreen,
        replaceAppScreen: replaceAppScreen,
        navigateAppScreen: navigateAppScreen,
        back: back,
        openExternalBrowser: openExternalBrowser
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useNavigator);


/***/ }),

/***/ 7287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _keyword_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./public/images/medicine-dictionary/mailChatBubbleTypingOval.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgMailChatBubbleTypingOval = function SvgMailChatBubbleTypingOval(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#mailChatBubbleTypingOval_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M17.178 1.928a11.92 11.92 0 0 0-11.303.512 11.92 11.92 0 0 0-4.04 16.453L.132 23.428a.857.857 0 0 0 .955 1.145L7.028 23.5a11.921 11.921 0 0 0 10.15-21.571Z",
    fill: "#D0EBFF"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m6.475 12.667-.001-.003-.001-.002H6.47l-.003-.001h-.002l-.002.001v.002l-.002.003.001.002.001.002h.002l.002.002.003-.001.002-.001v-.002l.002-.002Zm-1.715 0a1.708 1.708 0 1 1 3.417 0 1.708 1.708 0 0 1-3.417 0Zm7.246 0v-.003l-.002-.002h-.001L12 12.66h-.003l-.001.001-.001.002-.001.003v.002l.002.002h.001l.003.002.003-.001.001-.001.001-.002.001-.002Zm-1.714 0a1.708 1.708 0 1 1 3.416 0 1.708 1.708 0 0 1-3.416 0Zm7.245-.003v.005l-.001.002h-.002l-.002.002-.003-.001-.002-.001v-.002l-.001-.002v-.003l.001-.002h.002l.003-.001h.002l.002.001.001.002Zm-.005-1.705a1.708 1.708 0 1 0 0 3.416 1.708 1.708 0 0 0 0-3.416Z",
    fill: "#228BE6"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "mailChatBubbleTypingOval_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var mailChatBubbleTypingOval = (SvgMailChatBubbleTypingOval);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineBasicInfo.tsx



var MedicineBasicInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mailChatBubbleTypingOval, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "typography-ui-19sb shrink-1 select-text text-gray-700",
                        children: [
                            props.simplifiedName,
                            ", 어떤 약인가요?"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "성분"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.formattedIngredientName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "구분"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.ethicalType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m flex-shrink-0 select-text text-gray-400",
                                children: "업체"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15r flex-shrink-1 select-text text-gray-900",
                                children: props.companyName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineBasicInfo = (MedicineBasicInfo);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineDictionaryInnerSectionDivider.tsx

var MedicineDictionaryInnerSectionDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[1px] w-full bg-gray-40"
    });
};
/* harmony default export */ var ui_MedicineDictionaryInnerSectionDivider = (MedicineDictionaryInnerSectionDivider);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineDictionarySectionDivider.tsx

var MedicineDictionarySectionDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-[16px] w-full bg-gray-30"
    });
};
/* harmony default export */ var ui_MedicineDictionarySectionDivider = (MedicineDictionarySectionDivider);

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
;// CONCATENATED MODULE: ./public/images/medicine-dictionary/healthMedicalMedicines.svg
var healthMedicalMedicines_g, healthMedicalMedicines_defs;
function healthMedicalMedicines_extends() { return healthMedicalMedicines_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, healthMedicalMedicines_extends.apply(null, arguments); }

var SvgHealthMedicalMedicines = function SvgHealthMedicalMedicines(props) {
  return /*#__PURE__*/react.createElement("svg", healthMedicalMedicines_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), healthMedicalMedicines_g || (healthMedicalMedicines_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#healthMedicalMedicines_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M15.93 10.94a4.696 4.696 0 1 1 6.641 6.64l-5.69 5.69a4.696 4.696 0 1 1-6.64-6.641l5.689-5.69Z",
    fill: "#EF990D"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.25 9.564c-1.245 0-2.44.495-3.32 1.376l-2.845 2.844 6.641 6.641 2.845-2.844a4.697 4.697 0 0 0-3.32-8.017Z",
    fill: "#F4B54F"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6.653 13.972a6.652 6.652 0 1 0 0-13.305 6.652 6.652 0 0 0 0 13.305Z",
    fill: "#339AF0"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.086 8.39h13.133a6.697 6.697 0 0 0 0-2.142H.086a6.7 6.7 0 0 0 0 2.142Z",
    fill: "#86C6FF"
  }))), healthMedicalMedicines_defs || (healthMedicalMedicines_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "healthMedicalMedicines_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var healthMedicalMedicines = (SvgHealthMedicalMedicines);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideDosage.tsx







var MedicineGuideDosage = function(props) {
    var ref;
    var shouldShowDosageHtml = props.dosageHtml && props.dosageHtml.length > 0;
    var shouldShowButton = props.dosageHtml && props.dosageHtml.length > 0;
    var ref1 = (0,react.useState)(false), isDescriptionExpended = ref1[0], setIsDescriptionExpended = ref1[1];
    var toggleDescriptionExpended = function() {
        setIsDescriptionExpended(!isDescriptionExpended);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(healthMedicalMedicines, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            ", 용법/용량"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,style.cn)("flex flex-col "),
                children: [
                    (ref = props.dosages) === null || ref === void 0 ? void 0 : ref.map(function(dosageInfo) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col gap-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex flex-col gap-[12px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (0,style.cn)([
                                        "typography-ui-15r select-text text-gray-700",
                                        "relative pl-[20px]",
                                        'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                                        "flex gap-[8px]", 
                                    ]),
                                    children: dosageInfo
                                }, "dosageInfo-".concat(dosageInfo))
                            })
                        }, "dosage-".concat(dosageInfo));
                    }),
                    shouldShowDosageHtml && isDescriptionExpended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,style.cn)([
                            "mt-[20px] flex w-full flex-col gap-[12px]",
                            "typography-ui-15r select-text text-gray-700",
                            "rounded-[12px] bg-gray-20 p-[20px]", 
                        ]),
                        dangerouslySetInnerHTML: {
                            __html: (0,util/* sanitizeHtml */.Z6)(props.dosageHtml || "")
                        }
                    })
                ]
            }),
            shouldShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02]active:scale-[0.98]"
                ]),
                type: "button",
                onClick: toggleDescriptionExpended,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ease flex items-center gap-2 transition-all duration-300",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: isDescriptionExpended ? "접기" : "자세히 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "ease transition-transform duration-300",
                                isDescriptionExpended ? "rotate-180" : "rotate-0", 
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "keyboard_arrow_down",
                                size: 20
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideDosage = (MedicineGuideDosage);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/spark.svg
var spark_g, spark_defs;
function spark_extends() { return spark_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, spark_extends.apply(null, arguments); }

var SvgSpark = function SvgSpark(props) {
  return /*#__PURE__*/react.createElement("svg", spark_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), spark_g || (spark_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#spark_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m8.821 5.943 2.407 6.294 6.292 2.407-6.292 2.405-2.407 6.294-2.407-6.294L.12 14.644l6.294-2.407 2.407-6.294Z",
    fill: "#FFE066"
  }), /*#__PURE__*/react.createElement("path", {
    d: "m19.14 2.106 1.345 3.516L24 6.967 20.485 8.31l-1.344 3.516-1.345-3.516-3.516-1.343 3.516-1.345 1.345-3.516Z",
    fill: "#FCC419"
  }))), spark_defs || (spark_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "spark_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .667)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var spark = (SvgSpark);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideIndication.tsx



var MedicineGuideIndication = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spark, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "typography-ui-19sb shrink-1 select-text text-gray-700",
                        children: [
                            props.simplifiedName,
                            " 효능/효과"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-[20px]",
                children: (ref = props.indications) === null || ref === void 0 ? void 0 : ref.map(function(efficacy, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-[12px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col gap-[12px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "typography-ui-15r select-text text-gray-700",
                                children: efficacy
                            }, "efficacy-".concat(efficacy))
                        })
                    }, "efficacy-".concat(efficacy || index));
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideIndication = (MedicineGuideIndication);

// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideMagazine.tsx






var MedicineGuideMagazine = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: (0,style.cn)("typography-ui-19sb text-gray-700"),
                children: [
                    props.simplifiedName,
                    " 관련 건강 매거진"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full flex-col ",
                children: (ref = props.magazines) === null || ref === void 0 ? void 0 : ref.map(function(magazine, index, array) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                                onClickNavigateToScreen: props.onClickMagazine(magazine),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full items-center justify-between gap-[12px] rounded-[12px] py-[20px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-[4px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-17sb text-gray-700",
                                                    children: magazine.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-15r text-gray-500",
                                                    children: magazine.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "typography-ui-13r text-gray-300",
                                                    children: magazine.createdDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: magazine.titleImageUrl,
                                                alt: "magazine-image",
                                                className: "h-auto w-[96px] rounded-[8px]"
                                            })
                                        })
                                    ]
                                })
                            }, "magazine-".concat(magazine.magazinePid, "_").concat(index)),
                            index < array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[1px] w-full bg-gray-50"
                            })
                        ]
                    });
                })
            }),
            props.shouldShowMoreButton() && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02] active:scale-[0.98]"
                ]),
                type: "button",
                onClick: props.onClickMore,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: "더 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "keyboard_arrow_right",
                            size: 20
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideMagazine = (MedicineGuideMagazine);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/alertWarningTriangle.svg
var _path, _path2;
function alertWarningTriangle_extends() { return alertWarningTriangle_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, alertWarningTriangle_extends.apply(null, arguments); }

var SvgAlertWarningTriangle = function SvgAlertWarningTriangle(props) {
  return /*#__PURE__*/react.createElement("svg", alertWarningTriangle_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.667a2.144 2.144 0 0 0-1.908 1.166l-.003.006-7.86 15.719a2.149 2.149 0 0 0 .088 2.086 2.145 2.145 0 0 0 1.82 1.023h15.726a2.144 2.144 0 0 0 1.908-3.108l-7.86-15.72-.003-.006A2.144 2.144 0 0 0 12 2.666Z",
    fill: "#F03E3E"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.136 9.924c0-.493-.508-.894-1.136-.894-.627 0-1.136.4-1.136.894v4.293c0 .493.508.894 1.136.894.628 0 1.136-.4 1.136-.895V9.925ZM12 19.94c1.004 0 1.818-.64 1.818-1.43 0-.79-.814-1.431-1.818-1.431s-1.818.64-1.818 1.43c0 .79.814 1.431 1.818 1.431Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var alertWarningTriangle = (SvgAlertWarningTriangle);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideSideEffect.tsx







var MedicineGuideSideEffect = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isCautionExpanded = ref3[0], setIsCautionExpanded = ref3[1];
    var shouldShowPictogramArea = props.medicinePictogramImages && props.medicinePictogramImages.length > 0;
    var shouldShowInteractionHtml = props.interactionHtml && props.interactionHtml.length > 0;
    var shouldShowButton = props.interactionHtml && props.interactionHtml.length > 0;
    var toggleCautionExpanded = function() {
        setIsCautionExpanded(!isCautionExpanded);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alertWarningTriangle, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            ", 부작용 및 주의사항"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m select-text text-gray-400",
                                children: "부작용"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-[12px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex flex-col gap-[12px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "typography-ui-15r select-text text-gray-700",
                                        children: (ref = props.sideEffects) === null || ref === void 0 ? void 0 : ref.map(function(sideEffect) {
                                            return sideEffect;
                                        }).join(", ")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "typography-ui-15m select-text text-gray-400",
                                children: "주의사항"
                            }),
                            (ref1 = props.cautions) === null || ref1 === void 0 ? void 0 : ref1.map(function(label, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col gap-[12px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col gap-[12px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (0,style.cn)([
                                                "typography-ui-15r select-text text-gray-700",
                                                "relative pl-[20px]",
                                                'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                                                "flex gap-[8px]", 
                                            ]),
                                            children: label
                                        }, "caution-".concat(label))
                                    })
                                }, "caution-".concat(label || index));
                            })
                        ]
                    })
                ]
            }),
            shouldShowPictogramArea && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex gap-[12px] overflow-x-scroll md:overflow-x-hidden",
                children: (ref2 = props.medicinePictogramImages) === null || ref2 === void 0 ? void 0 : ref2.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image,
                        alt: "medicine-pictogram",
                        className: "h-auto w-[54px] object-contain"
                    }, "medicine-pictogram-".concat(index));
                })
            }),
            shouldShowInteractionHtml && isCautionExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)([
                    "mt-[20px] flex w-full flex-col",
                    "typography-ui-15r select-text text-gray-700",
                    "rounded-[12px] bg-gray-20 px-[20px] py-[16px]", 
                ]),
                dangerouslySetInnerHTML: {
                    __html: (0,util/* sanitizeHtml */.Z6)(props.interactionHtml || "")
                }
            }),
            shouldShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                buttonStyle: "outlined",
                buttonColor: "gray",
                size: "m",
                className: (0,style.cn)([
                    "w-full transition-all duration-300 ease-in-out",
                    "hover:scale-[1.02] active:scale-[0.98]"
                ]),
                type: "button",
                onClick: toggleCautionExpanded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2 transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "typography-ui-15sb text-gray-600",
                            children: isCautionExpanded ? "접기" : "자세히 보기"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "transition-transform duration-300 ease-in-out",
                                isCautionExpanded ? "rotate-180" : "rotate-0", 
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "keyboard_arrow_down",
                                size: 20
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideSideEffect = (MedicineGuideSideEffect);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideSource.tsx


var SOURCE_LIST = [
    {
        name: "커넥트디아이",
        url: "https://www.connectdi.com"
    },
    {
        name: "식품의약품안전처",
        url: "https://uvoice.mfds.go.kr"
    }, 
];
var MedicineGuideSource = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col gap-[20px] px-[24px] py-[28px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "typography-ui-19sb text-gray-700",
                children: "정보 출처"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-[12px]",
                children: SOURCE_LIST.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: (0,style.cn)([
                            "typography-ui-15r text-gray-700",
                            "relative pl-[20px]",
                            'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                            "flex gap-[8px]", 
                        ]),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15m text-gray-500",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cursor-pointer text-gray-300 underline decoration-gray-300 underline-offset-auto",
                                onClick: props.onClickSource(item.url),
                                children: item.url
                            })
                        ]
                    }, "source-".concat(item.name));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "typography-ui-13r text-gray-400",
                children: [
                    "본 콘텐츠의 저작권은 저자 또는 제공처에 있으며, 이를 무단 이용하는 경우 저작권법 등에 따라 법적책임을 질수 있습니다.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "외부저작권자가 제공한 콘텐츠는 닥터나우의 입장과 다를 수 있습니다."
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideSource = (MedicineGuideSource);

;// CONCATENATED MODULE: ./public/images/medicine-dictionary/wrappedGift.svg
var wrappedGift_path, wrappedGift_path2, _path3, _path4;
function wrappedGift_extends() { return wrappedGift_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, wrappedGift_extends.apply(null, arguments); }

var SvgWrappedGift = function SvgWrappedGift(props) {
  return /*#__PURE__*/react.createElement("svg", wrappedGift_extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), wrappedGift_path || (wrappedGift_path = /*#__PURE__*/react.createElement("path", {
    d: "m3 6.667 2.2-2.64a1 1 0 0 1 .768-.36h12.497a1 1 0 0 1 .832.445L21 6.666H3Z",
    fill: "#FFC96E"
  })), wrappedGift_path2 || (wrappedGift_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m8 6.667 1.111-3h6l.889 3H8Z",
    fill: "#8C5543"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M3 6.667h18v13.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-13.5Z",
    fill: "#FFCE7C"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8 6.667h8v7.443a.5.5 0 0 1-.75.433L12.233 12.8a.5.5 0 0 0-.474-.014l-3.035 1.518A.5.5 0 0 1 8 13.858V6.665Z",
    fill: "#A56953"
  })));
};
/* harmony default export */ var wrappedGift = (SvgWrappedGift);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideStorage.tsx



var MedicineGuideStorage = function(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(wrappedGift, {
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (0,style.cn)("typography-ui-19sb shrink-1 select-text text-gray-700"),
                        children: [
                            props.simplifiedName,
                            " 보관 방법"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-col gap-[8px]",
                children: (ref = props.storages) === null || ref === void 0 ? void 0 : ref.map(function(storage) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,style.cn)([
                            "typography-ui-15r select-text text-gray-700",
                            "relative pl-[20px]",
                            'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                            "flex gap-[8px]", 
                        ]),
                        children: storage
                    }, "storage-".concat(storage));
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideStorage = (MedicineGuideStorage);

// EXTERNAL MODULE: ./src/components/molecules/YouTubePlayer.tsx
var YouTubePlayer = __webpack_require__(5786);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineGuideVideoInfo.tsx



var MedicineGuideVideoInfo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col gap-[20px] px-[24px] py-[28px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (0,style.cn)("typography-ui-19sb select-text text-gray-700"),
                children: "영상으로 이해하는 복약정보"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,style.cn)("typography-ui-15r select-text text-gray-700"),
                children: props.videoLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-video w-full overflow-hidden rounded-lg border border-gray-200",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubePlayer/* default */.Z, {
                        videoUrl: props.videoLink
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineGuideVideoInfo = (MedicineGuideVideoInfo);

;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineImageWithName.tsx


var MedicineImageWithName = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)([
            "flex flex-col gap-[32px] px-[24px] py-[28px] md:flex-row md:gap-[32px]"
        ]),
        suppressHydrationWarning: true,
        children: [
            props.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: props.image,
                alt: props.imageAlt,
                className: "w-full rounded-[20px] object-contain md:w-[220px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15r select-text text-gray-400",
                        children: props.pharmaceuticalEffectLiteracy
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "typography-ui-19sb select-text text-gray-900",
                        children: props.name
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineImageWithName = (MedicineImageWithName);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/header.ts
var header = __webpack_require__(37072);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/common/AppInstallTopBanner.tsx
var AppInstallTopBanner = __webpack_require__(42411);
;// CONCATENATED MODULE: ./src/components/templates/medicine-dictionary/MedicineDictionaryDetailTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  gap: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
























var MedicineDictionaryDetailTemplate = function(param) {
    var viewModel = param.viewModel, topBannerViewModel = param.topBannerViewModel, client = param.client;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var shouldShowBreadCrumbs = client.clientType === app/* ClientType.WEB */.B.WEB;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB && topBannerViewModel.isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                style: {
                    top: 60
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInstallTopBanner/* default */.Z, {
                    onLogEvent: viewModel.onClickTopCta,
                    onClickClose: topBannerViewModel.hideBanner,
                    content: "web_content_bnr_service",
                    trackingInfo: {
                        campaign: "web_medicine_dictionary",
                        contentId: (ref = viewModel.medicineDictionaryItemByPublicId) === null || ref === void 0 ? void 0 : ref.getPublicId(),
                        contentTitle: (ref1 = viewModel.medicineDictionaryItemByPublicId) === null || ref1 === void 0 ? void 0 : ref1.getSimplifiedName()
                    }
                })
            }),
            client.isWebView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                type: header/* HeaderType.WithMobileHeader */.n.WithMobileHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    title: (ref2 = viewModel.medicineDictionaryItemByPublicId) === null || ref2 === void 0 ? void 0 : ref2.getBasicInfoName(),
                    hasLeftBackButton: true,
                    onClickBackButton: RNPlugins/* historyBack */.$i
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                suppressHydrationWarning: true,
                children: shouldShowBreadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                        visible: true,
                        breadCrumbs: viewModel.breadCrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineImageWithName, {
                        image: (ref3 = viewModel.medicineDictionaryItemByPublicId) === null || ref3 === void 0 ? void 0 : ref3.getRepresentativeImage(),
                        imageAlt: (ref4 = viewModel.medicineDictionaryItemByPublicId) === null || ref4 === void 0 ? void 0 : ref4.getSimplifiedName(),
                        name: (ref5 = viewModel.medicineDictionaryItemByPublicId) === null || ref5 === void 0 ? void 0 : ref5.getBasicInfoName(),
                        pharmaceuticalEffectLiteracy: (ref6 = viewModel.medicineDictionaryItemByPublicId) === null || ref6 === void 0 ? void 0 : ref6.getPharmaceuticalEffectLiteracy()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineBasicInfo, {
                        simplifiedName: (ref7 = viewModel.medicineDictionaryItemByPublicId) === null || ref7 === void 0 ? void 0 : ref7.getSimplifiedName(),
                        formattedIngredientName: (ref8 = viewModel.medicineDictionaryItemByPublicId) === null || ref8 === void 0 ? void 0 : ref8.getFormattedIngredientName(),
                        ethicalType: (ref9 = viewModel.medicineDictionaryItemByPublicId) === null || ref9 === void 0 ? void 0 : ref9.getEthicalType(),
                        companyName: (ref10 = viewModel.medicineDictionaryItemByPublicId) === null || ref10 === void 0 ? void 0 : ref10.getCompanyName()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {}),
                    viewModel.shouldShowMedicineGuideIndication() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideIndication, {
                                simplifiedName: (ref11 = viewModel.medicineDictionaryItemByPublicId) === null || ref11 === void 0 ? void 0 : ref11.getSimplifiedName(),
                                indications: (ref12 = viewModel.medicineDictionaryItemByPublicId) === null || ref12 === void 0 ? void 0 : ref12.getIndications()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideDosage() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideDosage, {
                                simplifiedName: (ref13 = viewModel.medicineDictionaryItemByPublicId) === null || ref13 === void 0 ? void 0 : ref13.getSimplifiedName(),
                                dosages: (ref14 = viewModel.medicineDictionaryItemByPublicId) === null || ref14 === void 0 ? void 0 : ref14.getDosages(),
                                dosageHtml: (ref15 = viewModel.medicineDictionaryItemByPublicId) === null || ref15 === void 0 ? void 0 : ref15.getDosageHtml()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideSideEffect() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideSideEffect, {
                                simplifiedName: (ref16 = viewModel.medicineDictionaryItemByPublicId) === null || ref16 === void 0 ? void 0 : ref16.getSimplifiedName(),
                                sideEffects: (ref17 = viewModel.medicineDictionaryItemByPublicId) === null || ref17 === void 0 ? void 0 : ref17.getSideEffects(),
                                interactionHtml: (ref18 = viewModel.medicineDictionaryItemByPublicId) === null || ref18 === void 0 ? void 0 : ref18.getInteractionHtml(),
                                cautions: (ref19 = viewModel.medicineDictionaryItemByPublicId) === null || ref19 === void 0 ? void 0 : ref19.getCaution(),
                                medicinePictogramImages: (ref20 = viewModel.medicineDictionaryItemByPublicId) === null || ref20 === void 0 ? void 0 : ref20.getMedicinePictogramImages()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryInnerSectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowMedicineGuideStorage() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideStorage, {
                        simplifiedName: (ref21 = viewModel.medicineDictionaryItemByPublicId) === null || ref21 === void 0 ? void 0 : ref21.getSimplifiedName(),
                        storages: (ref22 = viewModel.medicineDictionaryItemByPublicId) === null || ref22 === void 0 ? void 0 : ref22.getStorages()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {}),
                    viewModel.shouldShowMagazine() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideMagazine, {
                                simplifiedName: (ref23 = viewModel.medicineDictionaryItemByPublicId) === null || ref23 === void 0 ? void 0 : ref23.getSimplifiedName(),
                                magazines: viewModel.magazines,
                                onClickMagazine: viewModel.onClickMagazine,
                                onClickMore: viewModel.onClickMore,
                                shouldShowMoreButton: viewModel.shouldShowMagazineMoreButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {})
                        ]
                    }),
                    viewModel.shouldShowVideoInfo() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideVideoInfo, {
                                videoLink: (ref24 = viewModel.medicineDictionaryItemByPublicId) === null || ref24 === void 0 ? void 0 : ref24.getVideoLink()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionarySectionDivider, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineGuideSource, {
                        onClickSource: viewModel.onClickSource
                    }),
                    viewModel.shouldShowCtaButton() && /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyButtonWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    type: "button",
                                    buttonStyle: "contained",
                                    buttonColor: "primary",
                                    size: "xl",
                                    className: "w-full",
                                    onClick: viewModel.onClickCtaButton,
                                    children: "닥터나우로 편하게 진료받기"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "오늘 "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                                    children: "1,379명"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                    children: "이 비대면 진료로 처방받았어요"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var StickyButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93bde7c9-0"
})(_templateObject());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-93bde7c9-1"
})(_templateObject1());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-93bde7c9-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-93bde7c9-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15SB, ";\n    color: ").concat(theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-93bde7c9-4"
})(_templateObject4());
/* harmony default export */ var medicine_dictionary_MedicineDictionaryDetailTemplate = (MedicineDictionaryDetailTemplate);

// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
// EXTERNAL MODULE: ./src/hooks/useNavigator.ts
var useNavigator = __webpack_require__(35613);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/model/medicineDictionary.model.ts
var medicineDictionary_model = __webpack_require__(72115);
// EXTERNAL MODULE: ./src/hooks/medicine-dictionary/medicine-dictionary.gql.impl.tsx
var medicine_dictionary_gql_impl = __webpack_require__(16708);
;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryItemByPublicId.ts




var parseMedicineDictionary = function(data) {
    var _medicineImage, _formattedIngredientName, _image;
    return new medicineDictionary_model/* default */.Z({
        id: data.medicineDictionaryItemByPublicId.id,
        publicId: data.medicineDictionaryItemByPublicId.publicId,
        basicInfo: {
            name: data.medicineDictionaryItemByPublicId.basicInfo.name,
            simplifiedName: data.medicineDictionaryItemByPublicId.basicInfo.simplifiedName,
            pharmaceuticalEffectLiteracy: data.medicineDictionaryItemByPublicId.basicInfo.pharmaceuticalEffectLiteracy,
            medicineImage: (_medicineImage = data.medicineDictionaryItemByPublicId.basicInfo.medicineImage) !== null && _medicineImage !== void 0 ? _medicineImage : undefined,
            medicinePictogramImages: data.medicineDictionaryItemByPublicId.basicInfo.medicinePictogramImages
        },
        classificationInfo: {
            ethicalType: data.medicineDictionaryItemByPublicId.classificationInfo.ethicalType
        },
        companyInfo: {
            companyName: data.medicineDictionaryItemByPublicId.companyInfo.companyName
        },
        ingredientInfo: {
            formattedIngredientName: (_formattedIngredientName = data.medicineDictionaryItemByPublicId.ingredientInfo.formattedIngredientName) !== null && _formattedIngredientName !== void 0 ? _formattedIngredientName : undefined
        },
        medicineGuide: {
            indications: data.medicineDictionaryItemByPublicId.medicineGuide.indications,
            dosages: data.medicineDictionaryItemByPublicId.medicineGuide.dosages,
            dosageHtml: data.medicineDictionaryItemByPublicId.medicineGuide.dosageHtml,
            sideEffects: data.medicineDictionaryItemByPublicId.medicineGuide.sideEffects,
            cautions: data.medicineDictionaryItemByPublicId.medicineGuide.cautions,
            storages: data.medicineDictionaryItemByPublicId.medicineGuide.storages,
            videoLink: data.medicineDictionaryItemByPublicId.medicineGuide.videoLink,
            interactionHtml: data.medicineDictionaryItemByPublicId.medicineGuide.interactionHtml
        },
        packagingInfo: {
            image: (_image = data.medicineDictionaryItemByPublicId.packagingInfo.image) !== null && _image !== void 0 ? _image : undefined
        }
    });
};
var useMedicineDictionaryItemByPublicId = function(publicId) {
    var ref = (0,medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery */.me)({
        publicId: publicId
    }, {
        enabled: !!publicId,
        select: parseMedicineDictionary,
        staleTime: 1000 * 60 * 5
    }), medicineDictionaryItemByPublicId = ref.data;
    return {
        medicineDictionaryItemByPublicId: medicineDictionaryItemByPublicId
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryItemByPublicId = (useMedicineDictionaryItemByPublicId);
useMedicineDictionaryItemByPublicId.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, publicId) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                queryClient.prefetchQuery({
                    queryKey: medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.getKey */.me.getKey({
                        publicId: publicId
                    }),
                    queryFn: medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.fetcher */.me.fetcher({
                        publicId: publicId
                    }),
                    staleTime: 1000 * 60 * 5
                })
            ];
        });
    });
    return function(queryClient, publicId) {
        return _ref.apply(this, arguments);
    };
}();
useMedicineDictionaryItemByPublicId.getKey = function(publicId) {
    return medicine_dictionary_gql_impl/* useMedicineDictionaryItemByPublicIdQuery.getKey */.me.getKey({
        publicId: publicId
    });
};

;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionaryDetailViewModel.ts













var MAGAZINE_SIZE = 3;
var useMedicineDictionaryDetailViewModel = function(param) {
    var client = param.client, publicId = param.publicId;
    var router = (0,next_router.useRouter)();
    var pushScreen = (0,useNavigator/* default */.Z)().pushScreen;
    var id = publicId || router.query.id;
    var medicineDictionaryItemByPublicId = medicine_dictionary_useMedicineDictionaryItemByPublicId(id).medicineDictionaryItemByPublicId;
    var ref;
    var magazines = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: (ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) !== null && ref !== void 0 ? ref : "",
        size: MAGAZINE_SIZE,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE,
        enabled: !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getBasicInfoName())
    }).magazines;
    var breadCrumbs = (0,react.useMemo)(function() {
        var ref;
        return [
            {
                label: "의약품 사전",
                url: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path),
                logName: "medicine_dictionary"
            },
            {
                label: (ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getBasicInfoName()) !== null && ref !== void 0 ? ref : "",
                url: "".concat((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionaryItemByPublicId)),
                logName: "medicine_dictionary_detail"
            }, 
        ];
    }, [
        medicineDictionaryItemByPublicId
    ]);
    var shouldShowMedicineGuideIndication = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideIndications()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideIndications()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideDosage = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideDosages()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideDosages()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideSideEffect = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideSideEffects()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideSideEffects()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMedicineGuideStorage = function() {
        var ref;
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideStorages()) && ((ref = medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getMedicineGuideStorages()) === null || ref === void 0 ? void 0 : ref.length) > 0;
    };
    var shouldShowMagazine = function() {
        return magazines.length > 0;
    };
    var shouldShowVideoInfo = function() {
        return !!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getVideoLink());
    };
    var shouldShowCtaButton = function() {
        if (client.isWebView) {
            return false;
        }
        return true;
    };
    var onClickCtaButton = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
            category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
        }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
            drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
        }));
        router.push("".concat(common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path));
    };
    var onClickMagazine = function(magazine) {
        return function() {
            pushScreen({
                url: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid)
            });
        };
    };
    var onClickMore = function() {
        pushScreen({
            url: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH().HOME.path, "?keyword=").concat(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName(), "&tab=MAGAZINE")
        });
    };
    var onClickSource = function(url) {
        return function() {
            if (client.isWebView) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                    url: url
                });
                return;
            }
            window.open(url, "_blank");
        };
    };
    var shouldShowMagazineMoreButton = function() {
        if (!(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName())) {
            return false;
        }
        if (magazines.length < 3) {
            return false;
        }
        return !/[/@$!%*#?&]/.test(medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName());
    };
    var onClickTopCta = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
            category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
        }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
            drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
        }));
    };
    (0,react.useEffect)(function() {
        if (medicineDictionaryItemByPublicId) {
            pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()) && {
                category: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getPharmaceuticalEffectLiteracy()
            }, (medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()) && {
                drug: medicineDictionaryItemByPublicId === null || medicineDictionaryItemByPublicId === void 0 ? void 0 : medicineDictionaryItemByPublicId.getSimplifiedName()
            }));
        }
    }, [
        medicineDictionaryItemByPublicId
    ]);
    return {
        breadCrumbs: breadCrumbs,
        medicineDictionaryItemByPublicId: medicineDictionaryItemByPublicId,
        magazines: magazines,
        shouldShowMedicineGuideIndication: shouldShowMedicineGuideIndication,
        shouldShowMedicineGuideDosage: shouldShowMedicineGuideDosage,
        shouldShowMedicineGuideSideEffect: shouldShowMedicineGuideSideEffect,
        shouldShowMedicineGuideStorage: shouldShowMedicineGuideStorage,
        shouldShowMagazine: shouldShowMagazine,
        shouldShowVideoInfo: shouldShowVideoInfo,
        shouldShowCtaButton: shouldShowCtaButton,
        onClickCtaButton: onClickCtaButton,
        onClickMagazine: onClickMagazine,
        onClickMore: onClickMore,
        onClickSource: onClickSource,
        shouldShowMagazineMoreButton: shouldShowMagazineMoreButton,
        onClickTopCta: onClickTopCta
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionaryDetailViewModel = (useMedicineDictionaryDetailViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/medicine-dictionary/[id]/[keyword]/index.tsx
// PageDescription: 의약품 정보 상세 페이지 (키워드 포함)







var createMedicineDictionaryDetailLdJson = function(medicineDetail) {
    var ref;
    if (!medicineDetail) {
        return {};
    }
    return {
        "@context": "https://schema.org",
        "@type": "Drug",
        name: medicineDetail.getBasicInfoName(),
        nonProprietaryName: medicineDetail.getSimplifiedName(),
        activeIngredient: medicineDetail.getFormattedIngredientName(),
        isAvailableGenerically: medicineDetail.getEthicalType() === "일반의약품",
        isProprietary: medicineDetail.getEthicalType() === "전문의약품",
        prescriptionStatus: medicineDetail.getEthicalType() === "일반의약품" ? "https://schema.org/OTC" : "https://schema.org/PrescriptionOnly",
        warning: (ref = medicineDetail.getMedicineGuideCautions()) === null || ref === void 0 ? void 0 : ref.join(", "),
        identifier: {
            "@type": "PropertyValue",
            name: "Medicine ID",
            description: "DoctorNow Medicine Dictionary ID",
            value: medicineDetail.getPublicId()
        },
        image: medicineDetail.getRepresentativeImage(),
        brand: {
            "@type": "Organization",
            name: medicineDetail.getCompanyName()
        },
        recognizingAuthority: {
            "@type": "Organization",
            name: "식품의약품안전처",
            url: "https://uvoice.mfds.go.kr"
        },
        description: medicineDetail.getPharmaceuticalEffectLiteracy(),
        url: "".concat("https://doctornow.co.kr").concat((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDetail))
    };
};
var MedicineDictionaryDetailWithKeywordPage = function(param) {
    var client = param.client, publicId = param.publicId;
    var ref, ref1, ref2, ref3;
    var viewModel = medicine_dictionary_useMedicineDictionaryDetailViewModel({
        client: client,
        publicId: publicId
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var ldJson = createMedicineDictionaryDetailLdJson(viewModel.medicineDictionaryItemByPublicId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat((ref = viewModel.medicineDictionaryItemByPublicId) === null || ref === void 0 ? void 0 : ref.getBasicInfoName(), " 효능/효과, 부작용, 복용법 - 닥터나우 의약품 사전"),
                canonical: "".concat("https://doctornow.co.kr").concat((0,util/* createMedicineDictionaryDetailUrl */.at)(viewModel.medicineDictionaryItemByPublicId)),
                description: "".concat((ref1 = viewModel.medicineDictionaryItemByPublicId) === null || ref1 === void 0 ? void 0 : ref1.getPharmaceuticalEffectLiteracy(), " ").concat((ref2 = viewModel.medicineDictionaryItemByPublicId) === null || ref2 === void 0 ? void 0 : ref2.getSimplifiedName(), ". 효과부터 부작용, 복용법, 주의사항까지 ").concat((ref3 = viewModel.medicineDictionaryItemByPublicId) === null || ref3 === void 0 ? void 0 : ref3.getSimplifiedName(), "에 대한 정보를 닥터나우 의약품 사전에서 확인해보세요.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(medicine_dictionary_MedicineDictionaryDetailTemplate, {
                topBannerViewModel: topBannerViewModel,
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _keyword_ = (MedicineDictionaryDetailWithKeywordPage);


/***/ }),

/***/ 15951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ep": function() { return /* binding */ appInstallTopBannerState; },
/* harmony export */   "Ih": function() { return /* binding */ setAppDownloadCujModalState; },
/* harmony export */   "Ze": function() { return /* binding */ appDownloadCujModalState; },
/* harmony export */   "_l": function() { return /* binding */ getAppInstallTopBannerState; },
/* harmony export */   "dl": function() { return /* binding */ hideBanner; }
/* harmony export */ });
/* unused harmony exports CujTestDateState, getCujTestDateState, setCujTestDateState, setBannerState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);




var CujTestDateState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "testDate",
    default: [],
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("testCujDate")
    ]
});
var getCujTestDateState = function() {
    return getRecoil(CujTestDateState);
};
var setCujTestDateState = function(date) {
    setRecoil(CujTestDateState, date);
};
var appDownloadCujModalState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appDownloadCujModalState",
    default: {
        isShow: false
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appDownLoadCujModal")
    ]
});
var appInstallTopBannerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "appInstallTopBannerStateType",
    default: {
        isVisible: false,
        expirationTime: undefined
    },
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .sessionStorageEffect */ .j)("appInstallTopBanner")
    ]
});
var setAppDownloadCujModalState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appDownloadCujModalState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var getAppInstallTopBannerState = function() {
    var state = (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .getRecoil */ .$l)(appInstallTopBannerState);
    if (state.expirationTime === undefined) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    if (state.expirationTime && new Date() > new Date(state.expirationTime)) {
        setBannerState({
            isVisible: true,
            expirationTime: undefined
        });
    }
    return state;
};
// 배너 상태를 설정하는 함수
var setBannerState = function(state) {
    (0,recoil_nexus__WEBPACK_IMPORTED_MODULE_1__/* .setRecoil */ .z8)(appInstallTopBannerState, function(current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current, state);
    });
};
var hideBanner = function() {
    var expirationTime = new Date(new Date().getTime() + 30 * 60 * 1000).toISOString(); // 30분
    setBannerState({
        isVisible: false,
        expirationTime: expirationTime
    });
};


/***/ }),

/***/ 95613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ hooks_useAirbridgeDynamicLink; }
});

// UNUSED EXPORTS: useDebounceWithLoading

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(5322);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/firebase.ts + 10 modules
var firebase = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/shared/hooks/useAirbridgeDynamicLink.ts










var AIRBRIDGE_PARAM_PREFIX = "ab_";
var sanitizeEventName = function(eventName) {
    return eventName.replace(/[^\w]/g, "_");
};
var formatOptionsForLogging = function(options) {
    return Object.fromEntries(Object.entries(options).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            "".concat(AIRBRIDGE_PARAM_PREFIX).concat(key),
            typeof value === "number" ? value.toString() : value, 
        ];
    }));
};
var useAirbridgeDynamicLink = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "web_organic", initOptions = arguments.length > 1 ? arguments[1] : void 0;
    var router = (0,next_router.useRouter)();
    var getDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getDynamicLink */.Z.getDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, initOptions, options), linkType);
    };
    var getTrackingParams = function() {
        var linkType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridge/* default.getTrackingParams */.Z.getTrackingParams(linkType);
    };
    var createTrackingLinkAsync = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(channel, options) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    airbridge/* default.createTrackingLinkAsync */.Z.createTrackingLinkAsync(channel, options)
                ];
            });
        });
        return function createTrackingLinkAsync(channel, options) {
            return _ref.apply(this, arguments);
        };
    }();
    var logToFirebase = function(eventName, options) {
        var pageName = (0,logger/* getPageName */.j0)(router);
        var sanitizedEventName = sanitizeEventName(eventName);
        var formattedOptions = formatOptionsForLogging((0,_object_spread/* default */.Z)({}, initOptions, options));
        var payload = (0,_object_spread/* default */.Z)({
            page_name: pageName
        }, formattedOptions);
        if (env/* IS_LOCAL */.Kc) {
            console.log("logger >>", (0,_object_spread/* default */.Z)({
                eventName: sanitizedEventName
            }, payload));
            return;
        }
        firebase/* default.logEventOnlyFirebase */.Z.logEventOnlyFirebase(sanitizedEventName, payload);
    };
    var navigateWithTracking = function(eventName, options) {
        var linkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        var customOptions = (0,_object_spread/* default */.Z)({}, initOptions, options);
        logToFirebase(eventName, customOptions);
        airbridge/* default.setDynamicLink */.Z.setDynamicLink((0,_object_spread/* default */.Z)({
            channel: channel
        }, customOptions), linkType);
    };
    return {
        navigateWithTracking: navigateWithTracking,
        getDynamicLink: getDynamicLink,
        getTrackingParams: getTrackingParams,
        logToFirebase: logToFirebase,
        createTrackingLinkAsync: createTrackingLinkAsync
    };
};
/* harmony default export */ var hooks_useAirbridgeDynamicLink = (useAirbridgeDynamicLink);

// EXTERNAL MODULE: ./src/shared/hooks/useDebounceWithLoading.ts
var useDebounceWithLoading = __webpack_require__(78974);
;// CONCATENATED MODULE: ./src/shared/hooks/index.ts





/***/ }),

/***/ 78974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18149);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useDebounceWithLoading = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, options = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(value), debounced = ref[0], setDebounced = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var previousValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 객체의 실제 내용이 이전과 다르면 로딩 상태 시작
        if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(previousValue.current, value)) {
            setIsLoading(true);
            previousValue.current = value;
        }
        var handler = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            setDebounced(value);
            setIsLoading(false);
        }, delay, options);
        handler();
        return function() {
            handler.cancel();
        };
    }, [
        value,
        delay,
        options
    ]);
    return {
        debouncedValue: debounced,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounceWithLoading);


/***/ }),

/***/ 64214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatKeywordForUrl; },
/* harmony export */   "m": function() { return /* binding */ formatAuthorType; }
/* harmony export */ });
var formatKeywordForUrl = function(keyword) {
    var formattedKeyword = keyword.replace(/\/([^\s/]+)/g, "($1)") // /포 → (포), 한글 포함
    .replace(/[\s+]+/g, "-") // 공백, + → 하이픈
    .replace(/%/g, "퍼센트") // % → 퍼센트
    .replace(/[=&?#]/g, ""); // =, &, ?, # → 제거
    return formattedKeyword;
};
var formatAuthorType = function(authorType) {
    return authorType.split("_").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join("");
};


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,1498,2110,9970,8391,9653,8152,9774,2888,179], function() { return __webpack_exec__(94967); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);